export function encodeSize(size: string): string;
export function encodeSize(size: undefined): undefined;
export function encodeSize(size: null): null;
export function encodeSize(
  size: string | undefined | null,
): string | undefined | null;

export function encodeSize(size: string | undefined | null) {
  return (
    size &&
    size
      ?.trim()
      .toLowerCase()
      .replace(/\s|\/|,/g, "-")
      .replace(/\'|\"|\(|\)|,/g, "") // eslint-disable-line no-useless-escape
      .replace(/-+/g, "-")
      .replace(/\+/g, "-plus")
  );
}
